import abdul from "../../../assets/Abdul Salam.png";
import vinoth from "../../../assets/Vinoth_M photo.png";
import MukilProfile from "../../../assets/MukilArasi.png";
import AshfakProfile from '../../../assets/Ashfak.png';
import VinothKumarProfile from '../../../assets/vinoth.png';
import Shahulhameed from '../../../assets/ShahulHameed.png';
import Mathan from '../../../assets/MathanS.png';

export const productTeamProfile = [
  { id: 1, title: "Mukil Arasi M", imgUrl: MukilProfile },
  { id: 2, title: "Vinoth Kumar R", imgUrl: VinothKumarProfile },
  { id: 3, title: "Ashfak Ahamed A", imgUrl: AshfakProfile },
  { id: 4, title: "Vinoth M", imgUrl: vinoth},
  // { id: 2, title: "Revathi R", imgUrl: revathy },
  { id: 5, title: "Abdul Salam Irfan A", imgUrl: abdul},
  { id: 6, title: "Shahul Hameed J", imgUrl: Shahulhameed},
  { id: 7, title: "Mathan S", imgUrl: Mathan},
];
